<template>
  <div>
    <v-card class="mb-4" :loading="loading">
      <v-system-bar> Meldungen häufiger Absenzen </v-system-bar>
      <v-toolbar flat dense>
        <v-spacer></v-spacer
        ><FrequentAbsencesDialog
          :id="student.id"
          :term="term ? term.id : 0"
          @saved="fetchData"
        ></FrequentAbsencesDialog>
      </v-toolbar>
      <FrequentAbsencesList :items="frequentAbsences" />
    </v-card>
  </div>
</template>
<script>
import { defineComponent } from "vue";

import FrequentAbsencesList from "common/components/Absences/FrequentAbsencesList.vue";
import FrequentAbsencesDialog from "./components/FrequentAbsencesDialog.vue";

export default defineComponent({
  components: {
    FrequentAbsencesList,
    FrequentAbsencesDialog,
  },
  props: {
    id: { type: Number, default: 0 },
    term: { startDate: 0 },
    student: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      frequentAbsences: [],
      loading: false,
    };
  },
  computed: {
    canEdit() {
      return this.$_isClassTeacherOf(this.overview.student);
    },
  },
  watch: {
    id(oldValue, newValue) {
      if (oldValue != newValue) {
        this.fetchData();
      }
    },
    term() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      if (!this.id || !this.term) return;
      if (!this.$_hasRole("student")) {
        this.loading = true;
        this.frequentAbsences = await this.apiList({
          resource: "absence/frequentAbsences",
          query: `student=${this.id}&startDate=${this.term.startDate}&endDate=${this.term.endDate}`,
        });
        this.loading = false;
      }
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
